import React from 'react'
import { Grid, Typography, Box } from '@mui/material'
import HeaderBlue from '../components/HeaderBlue'
import FooterGris from '../components/FooterGris'

export default function About() {
  return (
    <>
      <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          style={{
            backgroundColor: '#cdcecf',
            height: '10rem',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <HeaderBlue />
        </Box>
        <Grid
          container
          style={{
            justifyContent: 'center',
            mt: 5,
            backgroundColor: 'white',
            maxWidth: '80%',
          }}
        >
          <p style={{ fontSize: '2rem' }}>Avís legal</p>
          <Typography
            variant="p"
            color="black"
            fontFamily="Consolas"
            component="div"
            padding="2rem"
            fontSize="1rem"
            lineHeight="2rem"
          >
            Amb la finalitat de donar compliment a l'article 10 de la Llei
            34/2002 de Serveis de la Societat de la Informació i Comerç
            Electrònic, informem l'usuari de les nostres dades: Denominació
            Social: Denominació social del teu negoci., d'ara endavant, «El
            prestador». Nom Comercial: Només si utilitzes un nom comercial
            diferent de la denominació social. Domicili Social: Adreça completa,
            codi postal, localitat i província. NIF: CIF o NIF de la teva
            empresa. Telèfon: Telèfon fix o mòbil operatiu de la teva empresa.
            Email: email operatiu de la teva empresa.
            <Typography
              component="div"
              variant="h5"
              style={{ marginTop: '20px', marginBotton: '10px' }}
            >
              Objecte
            </Typography>
            El prestador, responsable del lloc web, posa a disposició dels
            usuaris aquest document amb què pretén donar compliment a les
            obligacions disposades a la Llei 34/2002, de Serveis de la Societat
            de la Informació i del Comerç Electrònic (LSSI-CE ), així com
            informar a tots els usuaris del lloc web respecte a quines són les
            condicions dús del lloc web. Tota persona que accedeixi a aquest
            lloc web assumeix el paper d'usuari, comprometent-se a l'observança
            i el compliment rigorós de les disposicions aquí disposades, així
            com a qualsevol altra disposició legal que sigui aplicable. El
            prestador es reserva el dret a modificar qualsevol tipus
            d'informació que pogués aparèixer al lloc web, sense que hi hagi
            obligació de preavisar o posar en coneixement dels usuaris aquestes
            obligacions, entenent-se com a suficient amb la publicació al lloc
            web del prestador. Responsabilitat El prestador s'eximeix de
            qualsevol tipus de responsabilitat derivada de la informació
            publicada al vostre lloc web, sempre que aquesta informació hagi
            estat manipulada o introduïda per un tercer aliè al mateix. El lloc
            web del prestador pot utilitzar cookies (petits fitxers d'informació
            que el servidor envia a l'ordinador de qui accedeix a la pàgina) per
            dur a terme determinades funcions que són considerades
            imprescindibles per al correcte funcionament i visualització del
            lloc. Les galetes utilitzades al lloc web tenen, en tot cas,
            caràcter temporal amb l'única finalitat de fer més eficaç la seva
            transmissió ulterior i desapareixen en acabar la sessió de l'usuari.
            En cap cas no s'utilitzaran les cookies per recollir informació de
            caràcter personal. Afegeix aquí un enllaç a la teva política de
            galetes. Des del lloc web del client és possible que es redirigeixi
            a continguts de tercers llocs web. Atès que el prestador no pot
            controlar sempre els continguts introduïts pels tercers als seus
            llocs web, aquest no assumeix cap mena de responsabilitat respecte a
            aquests continguts. En tot cas, el prestador manifesta que procedirà
            a la retirada immediata de qualsevol contingut que pogués
            contravenir la legislació nacional o internacional, la moral o
            l'ordre públic, procedint a la retirada immediata de la redirecció a
            aquest lloc web, posant en coneixement de les autoritats competents
            el contingut en qüestió. El prestador no es fa responsable de la
            informació i continguts emmagatzemats, a títol enunciatiu però no
            limitatiu, en fòrums, xats, generadors de blocs, comentaris, xarxes
            socials o qualsevol altre mitjà que permeti a tercers publicar
            continguts de forma independent a la pàgina web del prestador. No
            obstant això i en compliment del que disposa l'art. 11 i 16 de la
            LSSI-CE, el prestador es posa a disposició de tots els usuaris,
            autoritats i forces de seguretat, i col·laborant de forma activa en
            la retirada o si és el cas bloqueig de tots aquells continguts que
            poguessin afectar o contravenir la legislació nacional, o
            internacional, drets de tercers o la moral i lordre públic. En cas
            que l'usuari consideri que hi ha al lloc web algun contingut que
            pogués ser susceptible d'aquesta classificació, es prega que ho
            notifiqui de manera immediata a l'administrador del lloc web. Aquest
            lloc web ha estat revisat i provat perquè funcioni correctament. En
            principi, es pot garantir el funcionament correcte els 365 dies de
            l'any, 24 hores al dia. Tot i això, el prestador no descarta la
            possibilitat que hi hagi certs errors de programació, o que
            esdevinguin causes de força major, catàstrofes naturals, vagues, o
            circumstàncies semblants que facin impossible l'accés a la pàgina
            web.
            <Typography
              component="div"
              variant="h5"
              style={{ marginTop: '20px', marginBotton: '10px' }}
            >
              Propietat Intel·lectual i Industrial
            </Typography>
            El lloc web, incloent a títol enunciatiu però no limitatiu la seva
            programació, edició, compilació i altres elements necessaris per al
            seu funcionament, els dissenys, logotips, text i/o gràfics són
            propietat del prestador o si escau disposa de llicència o
            autorització expressa per part dels autors. Tots els continguts del
            lloc web es troben degudament protegits per la normativa de
            propietat intel·lectual i industrial, així com inscrits als
            registres públics corresponents. Independentment de la finalitat per
            a la qual fossin destinats, la reproducció total o parcial, ús,
            explotació, distribució i comercialització requereix en tot cas
            l'autorització escrita prèvia per part del prestador. Qualsevol ús
            no autoritzat prèviament per part del prestador serà considerat un
            incompliment greu dels drets de propietat intel·lectual o industrial
            de lautor. Els dissenys, logotips, text i/o gràfics aliens al
            prestador i que poguessin aparèixer al lloc web, pertanyen als seus
            respectius propietaris, sent ells mateixos responsables de qualsevol
            possible controvèrsia que pogués suscitar-se respecte a aquests. En
            tot cas, el prestador compta amb lautorització expressa i prèvia per
            part dels mateixos. El prestador NO AUTORITZA expressament al fet
            que tercers puguin redirigir directament als continguts concrets del
            lloc web, havent de redirigir en tot cas al lloc web principal del
            prestador. El prestador reconeix a favor dels seus titulars els
            corresponents drets de propietat industrial i intel·lectual, i no
            implica la seva sola menció o aparició al lloc web l'existència de
            drets o responsabilitat alguna del prestador sobre aquests, com
            tampoc suport, patrocini o recomanació per part del mateix. Per
            realitzar qualsevol tipus d'observació respecte a possibles
            incompliments dels drets de propietat intel·lectual o industrial,
            així com sobre qualsevol dels continguts del lloc web, ho podeu fer
            a través del correu electrònic que figura a les dades
            identificatives al principi d'aquest document.
            <Typography
              component="div"
              variant="h5"
              style={{ marginTop: '20px', marginBotton: '10px' }}
            >
              Veracitat de la Informació
            </Typography>
            Tota la informació que facilita l'usuari ha de ser veraç. A aquest
            efecte, l'usuari garanteix l'autenticitat de les dades comunicades a
            través dels formularis per a la subscripció dels serveis. Serà
            responsabilitat de l'Usuari mantenir tota la informació facilitada a
            l'Empresa permanentment actualitzada de manera que respongui, a cada
            moment, a la seva situació real. En tot cas, l'Usuari serà l'únic
            responsable de les manifestacions falses o inexactes que faci i dels
            perjudicis que causi el prestador o tercers. Menors d'Edat Per a lús
            dels serveis, els menors dedat han dobtenir sempre prèviament el
            consentiment dels pares, tutors o representants legals, responsables
            últims de tots els actes realitzats pels menors al seu càrrec. La
            responsabilitat en la determinació de continguts concrets als quals
            accedeixen els menors correspon a aquells, és per això que si
            accedeixen a continguts no apropiats per Internet, s'hauran
            d'establir als seus ordinadors mecanismes, en particular programes
            informàtics, filtres i bloquejos, que permetin limitar els
            continguts disponibles i, tot i que no siguin infal·libles, són
            d'especial utilitat per controlar i restringir els materials a què
            poden accedir els menors.
            <Typography
              component="div"
              variant="h5"
              style={{ marginTop: '20px', marginBotton: '10px' }}
            >
              Obligació de fer un ús correcte de la web
            </Typography>
            L'Usuari es compromet a utilitzar la Web de conformitat a la Llei i
            al present Avís Legal, així com a la moral i als bons costums. A
            aquest efecte, l'Usuari s'abstindrà d'utilitzar la pàgina amb
            finalitats il·lícites o prohibides, lesives de drets i interessos de
            tercers, o que de qualsevol manera puguin danyar, inutilitzar,
            sobrecarregar, deteriorar o impedir la utilització normal d'equips
            informàtics o documents, arxius i tota mena de continguts
            emmagatzemats en qualsevol equip informàtic del prestador. En
            particular, ia títol indicatiu però no exhaustiu, l'Usuari es
            compromet a no transmetre, difondre o posar a disposició de tercers
            informacions, dades, continguts, missatges, gràfics, dibuixos,
            arxius de so o imatge, fotografies, enregistraments, programari i,
            en general, qualsevol classe de material que: (a) sigui contrària,
            menysprea o atempti contra els drets fonamentals i les llibertats
            públiques reconegudes constitucionalment, en tractats internacionals
            i altres normes vigents; (b) indueixi, inciti o promogui actuacions
            delictives, denigrants, difamatòries, violentes o, en general,
            contràries a la llei, a la moral ia l'ordre públic; (c) indueixi,
            inciti o promogui actuacions, actituds o pensaments discriminatoris
            per raó de sexe, raça, religió, creences, edat o condició; (d) sigui
            contrari al dret a l'honor, a la intimitat personal o familiar oa la
            pròpia imatge de les persones; (e) de qualsevol manera perjudiqui la
            credibilitat del prestador o de tercers; i (f) constitueixi
            publicitat il·lícita, enganyosa o deslleial.
            <Typography
              component="div"
              variant="h5"
              style={{ marginTop: '20px', marginBotton: '10px' }}
            >
              Llei Aplicable i Jurisdicció
            </Typography>
            Per a la resolució de totes les controvèrsies o qüestions
            relacionades amb el present lloc web o de les activitats que s'hi
            desenvolupin, serà aplicable la legislació espanyola, a la qual se
            sotmeten expressament les parts, sent competents per a la resolució
            de tots els conflictes derivats o relacionats amb el seu ús, els
            jutjats i tribunals introdueixen aquí la teva comunitat autònoma.
          </Typography>
        </Grid>
      </Grid>
      <FooterGris />
    </>
  )
}
